import { render, staticRenderFns } from "./ProductsPage.vue?vue&type=template&id=ebdc34e0"
import script from "./ProductsPage.vue?vue&type=script&lang=ts"
export * from "./ProductsPage.vue?vue&type=script&lang=ts"
import style0 from "./ProductsPage.vue?vue&type=style&index=0&id=ebdc34e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports